import { handleFormValidations } from './utils/form_validations'

$(document).on('turbolinks:load', function () {
  handleFormValidations()

  $(document).on('click', '#checkbox-all-period-excel-analytics', function() {
    tooglePeriodFields()
  })

  $(document).on('change', '#js-excel-analytics-report-type-select', function() {
    handleReportTypeChange($(this))
  })

  function handleReportTypeChange(reportTypeElement) {
    const formElement = $('#excel-analytics-form');
    const switchAllPeriod = $('.switch-checkbox-all-period-excel-analytics');
    const inputSwitchAllPeriod = $('#checkbox-all-period-excel-analytics');
    const containerFieldSetFilters = $('.fieldset-filters-container');
    const fieldsetFilters = $('.fieldset-filters');
    const siffsIdsFilter = $('.request_siff_ids');
    const placesIdsCheckboxesCheked = $('.request_places_ids :checkbox:checked');
    const servicesIdsCheckboxesCheked = $('.request_services_ids :checkbox:checked');
    const siffsIdsCheckboxesCheked = $('.request_siff_ids :checkbox:checked');
    const warningContainers = $('.warning-container');
    const serviceSelectionFieldset = $('.fieldset-service-selection');
    const serviceSelectionHr = $('.fieldset-service-selection-hr');

    const selectedValue = reportTypeElement.val() || '';
    formElement.attr('action', selectedValue || '/reports/excel_analytics/');
    const currentAction = formElement.attr('action');

    const dataAllowedArray = document.querySelectorAll('[target_reports]')

    if (dataAllowedArray.length) {
        for (const dataAllowedArrayElement of dataAllowedArray) {
            const dataAllowed = $(dataAllowedArrayElement).attr('target_reports').split(',');
            if (dataAllowed.includes(currentAction)) {
                $(dataAllowedArrayElement).show();
            } else {
                $(dataAllowedArrayElement).hide();
            }
        }
    }

    placesIdsCheckboxesCheked.trigger('click');
    servicesIdsCheckboxesCheked.trigger('click');
    siffsIdsCheckboxesCheked.trigger('click');
    switchAllPeriod.removeClass('is-disabled');
    warningContainers.hide();
    $('#js-inspection-by-service-select').val('').trigger('change');

    const isInspectionByService = /inspection_by_service_(simplified_)?report/.test(currentAction);

    serviceSelectionFieldset.hide();
    serviceSelectionHr.hide();
    fieldsetFilters.show();
    containerFieldSetFilters.show();
    siffsIdsFilter.show();
    $('.request_places_ids, .request_services_ids, .request_siff_ids').show();

    if (isInspectionByService) {
      serviceSelectionFieldset.show();
      serviceSelectionHr.show();
      fieldsetFilters.hide();
      containerFieldSetFilters.hide();
    } else if (/verified_methods_report/.test(currentAction)) {
      containerFieldSetFilters.hide();
    } else if (/construction_site_occurrence_report/.test(currentAction)) {
      if (!switchAllPeriod.hasClass('is-disabled')) {
        if (!inputSwitchAllPeriod.is(':checked')) inputSwitchAllPeriod.trigger('click');
        switchAllPeriod.addClass('is-disabled');
        warningContainers.show();
        containerFieldSetFilters.hide();
      }
    } else if (/services_schedule_report|planning_progress_report/.test(currentAction)) {
      siffsIdsFilter.hide();
    } else if (/occurrence_report_with_address/.test(currentAction)) {
      $('.request_places_ids, .request_services_ids, .request_siff_ids').hide();
    }
  }

  $(document).on('change', '#states_ids', function() {
    const stateSelect = $(this);
    const stateId = stateSelect.val();
    const citySelect = $('#cities_ids');
  
    if (!stateId || stateId.length === 0) return;
  
    const selectedStateId = stateId[0];
    const ajaxUrl = stateSelect.data('url');

    $.ajax({
      url: ajaxUrl,
      method: 'GET',
      data: { state_id: selectedStateId },
      dataType: 'json',
      success: function(response) {
        citySelect.empty();
        
        response.forEach(function(city) {
          citySelect.append(`<option value="${city.id}">${city.name}</option>`);
        });
  
        citySelect.multiselect('rebuild');
      },
      error: function(xhr, status, error) {
        console.error('Erro ao buscar cidades:', error);
      }
    });
  });
  
  function tooglePeriodFields() {
    const inputSwitchAllPeriod = $('#checkbox-all-period-excel-analytics');

    if (inputSwitchAllPeriod.is(':checked')) {
      $('.request_begin_at, .request_end_at, .pickadate').addClass('is-disabled')
    } else {
      $('.request_begin_at, .request_end_at, .pickadate').removeClass('is-disabled')
    }
  }

})
